<template>
  <nav class="sidebar-nav">
    <VuePerfectScrollbar
      :settings="psSettings"
      class="scroll-area"
      @ps-scroll-y="scrollHandle">
      <ul class="nav">
        <template v-for="(item, index) in navItems">
          <template v-if="item.title">
            <SidebarNavTitle
              v-if="getVisible(item.pages)"
              :key="index"
              :name="item.name"
              :classes="item.class"
              :wrapper="item.wrapper" />
          </template>
          <template v-else-if="item.divider">
            <SidebarNavDivider
              :key="index"
              :classes="item.class" />
          </template>
          <template v-else-if="item.label">
            <SidebarNavLabel
              :key="index"
              :name="item.name"
              :url="item.url"
              :icon="item.icon"
              :label="item.label"
              :classes="item.class" />
          </template>
          <template v-else>
            <template v-if="item.children">
              <!-- First level dropdown -->
              <SidebarNavDropdown
                v-if="getVisible(item.pages)"
                :key="index"
                :name="item.name"
                :url="item.url"
                :icon="item.icon"
                :class="item.navClass">
                <template v-for="(childL1, index1) in item.children">
                  <template v-if="childL1.children">
                    <!-- Second level dropdown -->
                    <SidebarNavDropdown
                      v-if="getVisible(childL1.pages)"
                      :key="index1"
                      :name="childL1.name"
                      :url="childL1.url"
                      :icon="childL1.icon"
                      @click="testClick">
                      <li
                        v-for="(childL2, index2) in childL1.children"
                        :key="index2"
                        class="nav-item">
                        <SidebarNavLink
                          v-if="getVisible(childL2.pages)"
                          :name="childL2.name"
                          :url="childL2.url"
                          :icon="childL2.icon"
                          :badge="childL2.badge"
                          :variant="item.variant" />
                      </li>
                    </SidebarNavDropdown>
                  </template>
                  <template v-else>
                    <SidebarNavItem
                      v-if="getVisible(childL1.pages)"
                      :key="index1"
                      :classes="item.class">
                      <SidebarNavLink
                        :name="childL1.name"
                        :url="childL1.url"
                        :icon="childL1.icon"
                        :badge="childL1.badge"
                        :variant="item.variant" />
                    </SidebarNavItem>
                  </template>
                </template>
              </SidebarNavDropdown>
            </template>
            <template v-else>
              <SidebarNavItem
                v-if="getVisible(item.pages)"
                :key="index"
                :classes="item.class">
                <SidebarNavLink
                  :name="item.name"
                  :url="item.url"
                  :icon="item.icon"
                  :badge="item.badge"
                  :variant="item.variant" />
              </SidebarNavItem>
            </template>
          </template>
        </template>
      </ul>
      <slot />
    </VuePerfectScrollbar>
  </nav>
</template>

<script>
import SidebarNavDivider from "./SidebarNavDivider";
import SidebarNavDropdown from "./SidebarNavDropdown";
import SidebarNavLink from "./SidebarNavLink";
import SidebarNavTitle from "./SidebarNavTitle";
import SidebarNavItem from "./SidebarNavItem";
import SidebarNavLabel from "./SidebarNavLabel";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  components: {
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem,
    SidebarNavLabel,
    VuePerfectScrollbar
  },
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {};
  },
  computed: {
    psSettings: () => {
      // ToDo: find better rtl fix
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX: getComputedStyle(document.querySelector("html")).direction !== "rtl",
        wheelPropagation: false,
        interceptRailY: styles => ({ ...styles, height: 0 })
      };
    }
  },
  mounted() {
    let cssList = document.querySelectorAll('.router-link-exact-active .router-link-active');
    for(var i = 0; i < cssList.length; i++) {
      cssList[i].parentElement.parentElement.parentElement.parentElement.classList.toggle('open');
    }

  },
  methods: {
    getVisible(e) {
      if (e) {
        let result = false;
        let pages = e;
        let roles = this.$store.getters.accessRoles;

        for (var i = 0; i < pages.length; i++) {
          for (var j = 0; j < roles.length; j++) {
            if (roles[j].page_id == pages[i]) {
              result = true;
              break;
            }
          }
        }

        return result;
      } else {
        return true;
      }
    },
    scrollHandle(evt) {}
  }
};
</script>

<style scoped lang="css">
.scroll-area {
  position: absolute;
  height: 100%;
  margin: auto;
}
</style>
